import { FC, CSSProperties } from 'react'
import ZestIcons from 'zest-free'

interface IconProps {
  uid: string
  className?: string
  color?: string
  onClick?: () => {}
  size?: number
  valign?: string
  style?: CSSProperties
}

// This is a wrapper component for the Zest Icons library. Seems like no tipescript support for this library yet.
const Icon: FC<IconProps> = ({
  uid,
  size = 24,
  color = '',
  valign = 'text-bottom',
  className = '',
  onClick = () => {},
  style: userStyle = {},
}) => {
  let paths
  let style: CSSProperties = { ...userStyle }
  if (uid in ZestIcons) {
    paths = ZestIcons[uid].paths
  } else {
    throw new Error('Invalid UID for icon: ' + uid)
  }
  if (valign) {
    style['verticalAlign'] = valign
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      style={style}
      onClick={onClick}
    >
      <g fill={color} dangerouslySetInnerHTML={{ __html: paths }} />
    </svg>
  )
}

export default Icon
